import {defineMessages} from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'ChangePassword.title',
    defaultMessage: 'Change your password'
  },
  oldPassword: {
    id: 'ChangePassword.oldPassword',
    defaultMessage: 'Current password'
  },
  newPassword: {
    id: 'ResetPassword.newPassword',
    defaultMessage: 'New password'
  },
  newPasswordConfirm: {
    id: 'confirmNewPassword',
    defaultMessage: 'Confirm new password'
  },
  passwordMismatch: {
    id: 'common.forms.passwordMismatch',
    defaultMessage: 'The passwords must match'
  },
  change: {
    id: 'common.actions.change',
    defaultMessage: 'Change'
  },
  updateSuccess: {
    id: 'ChangePassword.updateSuccess',
    defaultMessage: 'Password has been changed.'
  },
  updateFailure: {
    id: 'ChangePassword.updateFailure',
    defaultMessage: 'Invalid password, please try again.'
  },
  forgotYourPassword: {
    id: 'forgotYourPassword',
    defaultMessage: 'Forgot your password?'
  },
  goBack: {
    id: 'goBack',
    defaultMessage: 'Go back'
  },
  changePassword: {
    id: 'changePassword',
    defaultMessage: 'Change password'
  },
  passwordsDoNotMatch: {
    id: 'passwordsDoNotMatch',
    defaultMessage: 'Passwords do not match'
  },
  wrongCurrent: {
    id: 'wrongCurrent',
    defaultMessage: 'Wrong current password'
  },
  wrongCurrent4thTime: {
    id: 'wrongCurrent4thTime',
    defaultMessage: 'Wrong current password. If you forgot your password, request a {passwordResetLink}.'
  },
  passwordResetLink: {
    id: 'passwordResetLink',
    defaultMessage: 'password reset link'
  },
  wrongCurrent10thTime: {
    id: 'wrongCurrent10thTime',
    defaultMessage:
      'Your account is blocked after you entred the wrong password too many times. To unblock your account, request a {passwordResetLink}'
  },
  changedPassword: {
    id: 'changedPassword',
    defaultMessage: 'Password changed. Sign in to continue.'
  },
  canNotChangePassword: {
    id: 'canNotChangePassword',
    defaultMessage: "Password couldn't be changed"
  },
  meetAllRequirements: {
    id: 'meetAllRequirements',
    defaultMessage: 'Your new password should meet all requirements.'
  }
});

export default messages;
